import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Combine + dédoublonne des classes Tailwind. Le merge gère les conflits
 * (ex: `cn('px-4', 'px-6')` ⇒ `'px-6'`).
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
/**
 * Hash deterministe → couleur HSL stable. Utilisé pour les avatars par défaut.
 */
export function hashStringToHsl(input, saturation = 70, lightness = 55) {
    let hash = 0;
    for (let i = 0; i < input.length; i++) {
        hash = (hash << 5) - hash + input.charCodeAt(i);
        hash |= 0;
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
/**
 * Initiales (1-2 lettres) à partir d'un pseudo. "DamienAlfa" → "DA".
 */
export function getInitials(input) {
    if (!input)
        return '?';
    const parts = input.trim().split(/[\s_-]+/).filter(Boolean);
    if (parts.length === 0)
        return '?';
    if (parts.length === 1) {
        const p0 = parts[0];
        return p0.slice(0, 2).toUpperCase();
    }
    return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase();
}
/**
 * Formate un nombre en milliers (1234 → "1.2k", 1234567 → "1.2M").
 */
export function formatCompact(n) {
    return new Intl.NumberFormat('fr-FR', { notation: 'compact', maximumFractionDigits: 1 }).format(n);
}
